/**
 * Webinar email capture — submits the funnel form to /api/yeeter-subscribe.php.
 *
 * Sends the email + the microsite id + the current language (so the subscriber is emailed in the
 * right language) + an optional Turnstile token + a honeypot field. On success, swaps the form for
 * the success panel (double opt-in email is on its way).
 */
export function webinarCapture() {
  document.querySelectorAll('[data-webinar-capture]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const errEl = form.querySelector('[data-wc-error]');
      const btn = form.querySelector('button[type="submit"]');
      const tsInput = form.querySelector('[name="cf-turnstile-response"]');
      if (errEl) errEl.classList.add('hidden');

      const payload = {
        email: (form.email ? form.email.value : '').trim(),
        website: form.website ? form.website.value : '', // honeypot
        microsite: form.dataset.ms || '',
        lang: form.dataset.lang || 'cs',
        list: form.dataset.list || '',
        turnstile_token: tsInput ? tsInput.value : '',
      };

      if (btn) btn.disabled = true;
      try {
        const res = await fetch(form.dataset.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        const data = await res.json().catch(() => ({}));

        if (res.ok && data.ok) {
          form.classList.add('hidden');
          const section = form.closest('section');
          const success = section && section.querySelector('[data-wc-success]');
          if (success) success.classList.remove('hidden');
          return;
        }

        if (errEl) {
          errEl.textContent =
            data.error === 'captcha'
              ? 'Ověření se nezdařilo, zkus to prosím znovu.'
              : data.error === 'rate_limited'
                ? 'Příliš mnoho pokusů. Zkus to prosím za chvíli.'
                : data.error === 'invalid_email'
                  ? 'Zkontroluj prosím e-mailovou adresu.'
                  : 'Něco se pokazilo. Zkus to prosím znovu.';
          errEl.classList.remove('hidden');
        }
        if (window.turnstile && tsInput) window.turnstile.reset();
      } catch (err) {
        if (errEl) {
          errEl.textContent = 'Chyba připojení. Zkus to prosím znovu.';
          errEl.classList.remove('hidden');
        }
      } finally {
        if (btn) btn.disabled = false;
      }
    });
  });
}
